/* EMRKT.CH — Static registry of AI modules used to render the marketing
 * landing page and sidebar navigation. Backend `/api/modules` is the
 * runtime source of truth (status can change); this file is the static
 * presentational metadata (icons + i18n labels).
 *
 * 2026-07-30 — merged the old "Products" + "Prices" sidebar items into a
 * single "Produtos Vencedores" entry (renders CuratedPage which already
 * shows buy price, sell price, trust badges, publish button and the
 * operator AI chat). The legacy `pricing` route still resolves to the
 * same page as a graceful fallback if any bookmark points at it.
 */

import {
  Brain, TrendingUp, LineChart, Trophy, Truck, Search,
  Megaphone, Users, Wallet, ShieldAlert, Sparkles,
} from "lucide-react";

export const MODULES = [
  { id: "ceo",       Icon: Brain,       name: { en: "AI Coordinator",           pt: "Coordenador IA",           de: "KI-Koordinator",         fr: "Coordinateur IA",       it: "Coordinatore IA" } },
  { id: "trend",     Icon: TrendingUp,  name: { en: "Discover trends",          pt: "Descobrir tendências",     de: "Trends entdecken",       fr: "Découvrir tendances",   it: "Scopri tendenze" } },
  { id: "market",    Icon: LineChart,   name: { en: "Market size",              pt: "Tamanho do mercado",       de: "Marktgröße",             fr: "Taille du marché",      it: "Dimensione mercato" } },
  { id: "product",   Icon: Trophy,      name: { en: "Winning products",         pt: "Produtos Vencedores",      de: "Gewinner-Produkte",      fr: "Produits gagnants",     it: "Prodotti vincenti" } },
  { id: "supplier",  Icon: Truck,       name: { en: "Suppliers & stock",        pt: "Fornecedores e stock",     de: "Lieferanten & Lager",    fr: "Fournisseurs & stock",  it: "Fornitori e stock" } },
  { id: "seo",       Icon: Search,      name: { en: "Google visibility",        pt: "Visibilidade no Google",   de: "Google-Sichtbarkeit",    fr: "Visibilité Google",     it: "Visibilità Google" } },
  { id: "marketing", Icon: Megaphone,   name: { en: "Marketing & campaigns",    pt: "Marketing e campanhas",    de: "Marketing & Kampagnen",  fr: "Marketing & campagnes", it: "Marketing e campagne" } },
  { id: "customer",  Icon: Users,       name: { en: "Customers & support",      pt: "Clientes e apoio",         de: "Kunden & Support",       fr: "Clients & support",     it: "Clienti e supporto" } },
  { id: "finance",   Icon: Wallet,      name: { en: "Money & profit",           pt: "Dinheiro e lucro",         de: "Geld & Gewinn",          fr: "Argent & profit",       it: "Denaro e profitto" } },
  { id: "guardian",  Icon: ShieldAlert, name: { en: "Safety & legal",           pt: "Segurança e legal",        de: "Sicherheit & Recht",     fr: "Sécurité & légal",      it: "Sicurezza e legale" } },
  { id: "learning",  Icon: Sparkles,    name: { en: "Auto-improve",             pt: "Auto-melhoria",            de: "Selbst-Verbesserung",    fr: "Auto-amélioration",     it: "Auto-miglioramento" } },
];

export function moduleName(id, lang) {
  const m = MODULES.find((x) => x.id === id);
  if (!m) return id;
  return m.name[lang] || m.name.en;
}

export function moduleIcon(id) {
  const m = MODULES.find((x) => x.id === id);
  return m ? m.Icon : Sparkles;
}
